var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("collapsible-card", {
    attrs: {
      "collapse-id": "notified-referrers-card",
      "store-path": "notifiedReferrers",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("client-profile.actions.notifySuscribers")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("client-profile-details-loader")
              : _c("div", { staticClass: "row no-gutters" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 d-flex justify-content-center flex-column",
                    },
                    [
                      _c("p", { staticClass: "mb-2" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "client-profile.messages.notifySuscribers.0"
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "m-0 font-italic font-sm" }, [
                        _c("span", { staticClass: "bold text-capitalize" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm.$tc("global.words.note", 1)
                              )
                            ) + ":"
                          ),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "client-profile.messages.notifySuscribers.1"
                              )
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 mt-3" },
                    [
                      _c("server-side-referrers-select", {
                        ref: "referrersSelect",
                        attrs: {
                          id: "notified-referrers-select",
                          "pre-selected-referrer": _vm.notifiedReferrers,
                          "close-on-select": false,
                          multiple: "",
                        },
                        on: {
                          change: _vm.toggleReferrerSubscription,
                          "handle-referrer": _vm.handleReferrer,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }